import React, { useEffect } from 'react';
import { Router, Switch, Route } from 'react-router-dom';
import ShareScreen from '@common/screens/ShareScreen';
import RenderScreen from '@common/screens/RenderScreen';
import history from './history';
import ShareLink from '@common/screens/ShareLink';
import ShareScreenModal from '@common/screens/ShareScreenModal';
import ShareScreenUrl from '@common/screens/ShareScreenUrl';
import useAppDetail from '@common/hooks/app';
import { AppVersion, Platform as PlatformType } from 'click-types';
import { useParams } from '@common/routes/hooks';
import Loading from '@common/components/Loading';

const PreviewRoute = () => {
  const { appId } = useParams();
  const { data, isLoading } = useAppDetail({
    appId: appId,
    isShareScreen: true,
  });

  const { version, platform } = data ?? {
    version: AppVersion.V3,
    platform: PlatformType.MOBILE,
  };
  if (isLoading) {
    return <Loading />;
  }
  const isV4Responsive =
    version === AppVersion.V4 && platform === PlatformType.RESPONSIVE;

  if (isV4Responsive) {
    return <ShareScreenUrl />;
  }
  return <RenderScreen />;
};

const AppIdRoute = () => {
  const { appId } = useParams();
  const { data, isLoading } = useAppDetail({
    appId: appId,
    isShareScreen: true,
  });

  const { version, platform } = data ?? {
    version: AppVersion.V3,
    platform: PlatformType.MOBILE,
  };
  if (isLoading) {
    return <Loading />;
  }
  const shouldUseRenderScreen =
    version === AppVersion.V4 && platform === PlatformType.RESPONSIVE;

  if (shouldUseRenderScreen) {
    return <RenderScreen />;
  }
  return <ShareScreen />;
};

export default function AppRoutes() {
  useEffect(() => {
    // Listen for the response
    window.addEventListener('message', function (event) {
      try {
        // Verify the origin of the message
        if (event?.data?.type === 'click__get__cookie') {
          const cookie = event.data.cookie;
          console.log('=== Cookie received:', cookie);
          localStorage.setItem('click__cookie', cookie);
        }
        if (event?.data?.type === 'click__get__current_url') {
          const currentUrl = event.data.currentUrl;
          console.log('=== currentUrl received:', currentUrl);
          localStorage.setItem('click__current_url', currentUrl);
        }
      } catch (error) {
        console.error('=== error', error);
        // do nothing
      }
    });
  }, []);

  return (
    <Router history={history}>
      <Switch>
        <Route path="/share/:shortUrl" component={ShareLink} />
        <Route exact path="/" component={ShareScreen} />
        <Route path="/preview/:appId" component={PreviewRoute} />
        <Route path="/preview-v4/:appId" component={RenderScreen} />
        <Route path="/share-modal/:appId" component={ShareScreenModal} />
        <Route path="/share-app/:appId" component={ShareScreenUrl} />
        <Route path="/:appId" component={AppIdRoute} />
      </Switch>
    </Router>
  );
}
